<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
            <page-tool-bar
                :loading="loader"
                show_search
                :search.sync="search"
                show_date_start
                :date_start.sync="date_start"
                show_date_end
                :date_end.sync="date_end"
            >
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="dialog = !dialog" color="green" dark>
                            <v-icon small dark left>add_box</v-icon>
                            Tạo Phiếu Mới
                        </v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            disable-initial-sort
                            :headers="headers"
                            :items="items"
                            item-key="id"
                            :rows-per-page-items="rowPerPage"
                            :search="search"
                            :loading="loader"
                        >
                            <template #items="props">
                                <tr>
                                    <td @click.stop.prevent class="text-no-wrap text-center">
                                        <v-menu offset-y>
                                            <v-btn icon slot="activator">
                                                <v-icon small color="#464D69">settings</v-icon>
                                            </v-btn>
                                            <v-list>
                                                <v-list-tile
                                                    @click="showDetail(props.item)"
                                                >
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-assignment"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Chi tiết
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    @click="trigger_edit_component = !trigger_edit_component; chosen_receipt = props.item"
                                                >
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Chỉnh sửa
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </td>
                                    <td class="text-center text-no-wrap">{{ props.item.date_in | formatTimeServer }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.member_count }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.motorbike_count }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.bike_count }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.electric_count }}</td>
                                    <!-- <td class="text-center text-no-wrap">{{ props.item.electric_check_out_count }}</td> -->
                                    <td class="text-center text-no-wrap">{{ props.item.water_count }}</td>
                                    <!-- <td class="text-center text-no-wrap">{{ props.item.water_check_out_count }}</td> -->
                                    <td class="text-center text-no-wrap">{{ props.item.is_washing_machine ? 'Có' : 'Không' }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.is_air_conditioner ? 'Có' : 'Không' }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.internet_data ? props.item.internet_data.name : '' }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.internet_data && props.item.internet_data.price ? props.item.internet_data.price.toLocaleString('en-EN') : '' }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
		</v-container>
        <v-dialog transition="slide-y-transition" v-model="dialog" max-width="80%">
            <app-card height="200px">
                <app-section-loader :status="form_loader"></app-section-loader>
                <h4>PHIẾU THÔNG TIN NHẬN PHÒNG</h4>
                <p class="fs-14 grey--text mb-0">Tạo phiếu thông tin nhận phòng</p>
                <p v-if="form.room_id && form.is_included_air_conditioner" class="v-badge primary mb-0">Phòng {{ form.room_id}} có máy lạnh trả trước</p>
                <v-btn v-if="role === 'ADMIN'" @click="$refs.inputUpload.click()" color="green" dark>
                    Nhập excel (admin)
                </v-btn>
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="form.building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    @change="getReceiptNewestNumber"
                                    :rules="requireText"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Số phòng"
                                    :disabled="loading.submit"
                                    v-model="form.room_id"
                                    :items="room_ids"
                                    item-text="room_id"
                                    item-value="rooms_id"
                                    prepend-icon="meeting_room"
                                    required
                                    :rules="requireText"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 v-if="alert.show">
                                <v-alert
                                    :value="alert.show"
                                    :type="alert.type"
                                    outline
                                >
                                    {{ alert.text }}
                                </v-alert>
                            </v-flex>
                            <template v-if="form.room_state_id">
                                <v-flex xs12 md3>
                                    <v-menu
                                        :close-on-content-click="false"
                                        v-model="menu_date_in"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            v-model="form.date_in"
                                            label="Ngày nhận phòng"
                                            :disabled="loading.submit"
                                            prepend-icon="event"
                                            readonly
                                            :rules="requireText"
                                        ></v-text-field>
                                        <v-date-picker locale="vi-VI" v-model="form.date_in" @input="menu_date_in = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        label="Mã quản lý"
                                        :disabled="true"
                                        type="text"
                                        v-model="form.room_state_id"
                                        prepend-icon="book"
                                        required
                                        :rules="requireText"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        label="Số Chứng Từ"
                                        :disabled="loading.submit"
                                        type="text"
                                        v-model="form.receipt_id"
                                        prepend-icon="book"
                                        required
                                        :rules="requireText"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        :items="[1,2,3,4,5,6,7]"
                                        v-model.number="form.member_count"
                                        label="Số người ở"
                                        @change="updateCustomerCount"
                                        :rules="requireNumber"
                                        prepend-icon="people"
                                        :disabled="loading.submit"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        :label="'Số điện' + (form.electric_old !== undefined ? ` (SC: ${form.electric_old})` : '')"
                                        :disabled="loading.submit"
                                        v-model.number="form.electric_count"
                                        :rules="requireElectricWater"
                                        type="number"
                                        min="0"
                                        prepend-icon="receipt"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        :label="'Số nước' + (form.water_old !== undefined ? ` (SC: ${form.water_old})` : '')"
                                        :disabled="loading.submit"
                                        v-model.number="form.water_count"
                                        :rules="requireElectricWater"
                                        type="number"
                                        min="0"
                                        prepend-icon="timer"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Máy giặt"
                                        :disabled="loading.submit"
                                        v-model="form.is_washing_machine"
                                        :items="list_washing_machine"
                                        prepend-icon="local_laundry_service"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Máy lạnh"
                                        :disabled="true"
                                        v-model="form.is_air_conditioner"
                                        :items="list_air_conditioner"
                                        prepend-icon="ac_unit"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Internet"
                                        :disabled="true"
                                        v-model="form.internet"
                                        :items="list_internet"
                                        prepend-icon="wifi"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        :label="'Giá tiền internet: ' + (form.internet_data.price ? ` ${form.internet_data.price.toLocaleString('en-EN')} vnd` : '')"
                                        type="number"
                                        min="0"
                                        v-model.number="form.internet_data.price"
                                        :disabled="!form.internet || loading.submit"
                                        prepend-icon="attach_money"
                                    >
                                        <template slot="append">
                                            VND
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <template v-for="(customer, index) in form.customers">
                                    <v-flex :key="`name ${index + 1}`" xs12 md3>
                                        <v-text-field
                                            :label="`Họ tên thành viên #${index + 1}`"
                                            :disabled="loading.submit"
                                            v-model="customer.name"
                                            prepend-icon="account_box"
                                            required
                                            :rules="requireText"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex :key="`contact_phone ${index + 1}`" xs12 md3>
                                        <v-text-field
                                            :label="`Số điện thoại #${index + 1}`"
                                            :disabled="loading.submit"
                                            v-model="customer.phone"
                                            prepend-icon="contact_phone"
                                            :rules="requirePhone"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex :key="`motorbike ${index + 1}`" xs12 md3>
                                        <v-text-field
                                            :label="`Biển số xe #${index + 1}`"
                                            :disabled="loading.submit"
                                            v-model="customer.motorbike"
                                            prepend-icon="motorcycle"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex :key="`bike ${index + 1}`" xs12 md3>
                                        <v-select
                                            :label="`Xe đạp #${index + 1}`"
                                            :disabled="loading.submit"
                                            v-model="customer.is_bike"
                                            :items="list_bike"
                                            prepend-icon="motorcycle"
                                        ></v-select>
                                    </v-flex>
                                </template>
                            </template>
                        </v-layout>
                    </v-container>
                    <v-card-actions v-if="form.room_state_id">
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="loading.submit"
                            @click="cancelInput"
                        >
                            Trở về
                        </v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="primary"
                        >
                            Tạo Phiếu
                        </v-btn>
                    </v-card-actions>
                    <!-- <v-btn @click="clear" color="primary">{{$t("message.clear")}}</v-btn> -->
                </v-form>
            </app-card>
        </v-dialog>
        <v-dialog v-model="dialogDetail" max-width="80%">
            <app-card>
                <app-section-loader :status="form_loader"></app-section-loader>
                <h4>Chi tiết</h4>
                <p class="fs-14 grey--text">Phiếu thông tin nhận phòng số: {{ chosen_receipt.receipt_id}}</p>
                <v-data-table
                    :headers="detail_headers"
                    :items="chosen_receipt.customers"
                    disable-initial-sort
                    item-key="id"
                >
                    <template #headers="props">
                        <tr>
                            <th class="text-xs-center fw-bold" v-for="header in props.headers" :key="header.text">
                                {{ header.text }}
                            </th>
                        </tr>
                    </template>
                    <template #items="props">
                        <tr>
                            <td class="text-center text-no-wwrap">{{ props.item.name }}</td>
                            <td class="text-center text-no-wwrap">{{ props.item.phone }}</td>
                            <td class="text-center text-no-wwrap">{{ props.item.motorbike }}</td>
                            <td class="text-center text-no-wwrap">{{ props.item.is_bike ? 'Có' : 'Không' }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </app-card>
        </v-dialog>

        <edit-receipt-component
            @updateCurrentReceipt="updateCurrentReceipt"
            hide_button
            receipt_type="check_in"
            title="CHỈNH SỬA PHIẾU NHẬN PHÒNG"
            :trigger="trigger_edit_component"
            :edit_field="edit_field"
            :selected_receipt="chosen_receipt"
            #default="slotProps"
        >
            <template v-for="(customer, index) in slotProps.form.customers">
                <v-flex :key="`name ${index + 1}`" xs12 md3>
                    <v-text-field
                        :label="`Họ tên thành viên #${index + 1}`"
                        :disabled="loading.submit"
                        v-model="customer.name"
                        prepend-icon="account_box"
                        required
                        :rules="requireText"
                    ></v-text-field>
                </v-flex>
                <v-flex :key="`contact_phone ${index + 1}`" xs12 md3>
                    <v-text-field
                        :label="`Số điện thoại #${index + 1}`"
                        :disabled="loading.submit"
                        v-model="customer.phone"
                        prepend-icon="contact_phone"
                        :rules="requirePhone"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex :key="`motorbike ${index + 1}`" xs12 md3>
                    <v-text-field
                        :label="`Biển số xe #${index + 1}`"
                        :disabled="loading.submit || !chosen_receipt.customers[index].motorbike"
                        v-model="customer.motorbike"
                        prepend-icon="motorcycle"
                    ></v-text-field>
                </v-flex>
                <v-flex :key="`bike ${index + 1}`" xs12 md3>
                    <v-select
                        :label="`Xe đạp #${index + 1}`"
                        :disabled="true"
                        v-model="customer.is_bike"
                        :items="list_bike"
                        prepend-icon="motorcycle"
                    ></v-select>
                </v-flex>
            </template>
        </edit-receipt-component>
	</div>
</template>

<script>
import api from '../../api'
import { buildParamQuery, formatTimeServer } from '../../helpers/helpers.js'
import moment from 'moment'
import XLSX from 'xlsx'
import utf8 from 'utf8'
import EditReceiptComponent from '../../components/Phieu/EditReceiptComponent'
import { list_building } from '../../constants/db-config'

export default {
    name: "phieu-thong-tin-nhan-phong",
    components: {
        EditReceiptComponent
    },
    data() {
        const list_washing_machine = [
            {text: 'Có', value: true},
            {text: 'Không', value: false}
        ];
        return {
            dialog: false,
            dialogDetail: false,
            loader: false,
            form_loader: false,
            form: {
                receipt_id: '',
                building: '',
                room_id: '',
                date_in: new Date().toISOString().substr(0, 10),
                electric_count: '',
                water_count: '',
                is_washing_machine: '',
                is_air_conditioner: '',
                internet: '',
                internet_data: {},
                customers: [{}],
                member_count: 1,
                is_included_air_conditioner: false,
            },
            menu_date_in: false,
            list_building: [
                ...list_building,
            ],
            list_washing_machine,
            list_air_conditioner: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
            list_bike: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
            list_internet: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
            headers: [
                { text: "Thao tác", align: "center", sortable: false, value: "" },
                { text: "Ngày đến ở", align: "center", sortable: true, value: "date_in" },
                { text: "Chứng từ", align: "center", sortable: true, value: "receipt_id" },
                { text: "Phòng", align: "center", sortable: true, value: "room_id" },
                { text: "Số thành viên", align: "center", sortable: true, value: "member_count" },
                { text: "Xe máy", align: "center", sortable: true, value: "motor = " },
                { text: "Xe đạp", align: "center", sortable: true, value: " = " },
                { text: "Số điện", align: "center", sortable: true, value: "electric_count" },
                // { text: "Số điện cũ", align: "center", sortable: true, value: "electric_count" },
                { text: "Số nước", align: "center", sortable: true, value: "water_count" },
                // { text: "Số nước cũ", align: "center", sortable: true, value: "water_count" },
                { text: "Máy giặt", align: "center", sortable: true, value: "is_washing_machine" },
                { text: "Máy lạnh", align: "center", sortable: true, value: "is_air_conditioner" },
                { text: "Nhà mạng", align: "center", sortable: true, value: "internet_data.name" },
                { text: "Giá mạng", align: "center", sortable: true, value: "internet_data.price" }
            ],
            detail_headers: [
                { text: "Tên", align: "center", sortable: false, value: "name" },
                { text: "SDT", align: "center", sortable: false, value: "name" },
                { text: "Xe máy", align: "center", sortable: false, value: "motorbike" },
                { text: "Xe đạp", align: "center", sortable: false, value: "is_bike" }
            ],
            items: [],
            loading: {
                submit: false
            },
            chosen_receipt: {},
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            input_excel: null,
            deposits: [],
            chosen_building: 'BN',
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Mã số phiếu', value: 'receiptId' },
                { text: 'Mã quản lý', value: 'roomStateId' },
                { text: 'Tên khách hàng', value: 'name' },
            ],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substr(0, 10),
            search:'',
            search_type: 'roomId',
            requireElectricWater: [
                v => !!v || v === 0 || "Vui lòng nhập thông tin này",
                v => (v >= 0) || "Vui lòng nhập chính xác số điện nước"
            ],
            requireNumber: [
                v => !!v || "Vui lòng nhập thông tin này",
            ],
            requireText: [
                v => !!v || "Vui lòng nhập thông tin này",
            ],
            requirePhone: [
                v => !!v || 'Vui lòng nhập thông tin này',
                v => (v && v.length <= 10) || 'SDT phải ngắn hơn 10 ký tự',
            ],
            edit_field: {
                receipt_id: {
                    type: "text",
                    flex_attr: "xs12 sm3",
                    label: "Số chứng từ",
                    disabled: false,
                    prepend_icon: "book",
                    rule: "require"
                },
                date_in: {
                    type: "date",
                    flex_attr: "xs12 sm3",
                    label: "Ngày nhận phòng",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "require",
                    min: 0,
                },
                is_washing_machine: {
                    type: "list",
                    flex_attr: "xs12 sm3",
                    label: "Máy giặt",
                    disabled: false,
                    items: list_washing_machine,
                    prepend_icon: "local_laundry_service",
                    rule: "require",
                },
                electric_count: {
                    type: "number",
                    flex_attr: "xs12 sm3",
                    label: "Số điện",
                    disabled: false,
                    prepend_icon: "receipt",
                    rule: "require",
                    min: 0,
                },
                water_count: {
                    type: "number",
                    flex_attr: "xs12 sm3",
                    label: "Số nước",
                    disabled: false,
                    prepend_icon: "timer",
                    rule: "require",
                    min: 0,
                },
                edit_note: {
                    type: "text",
                    flex_attr: "xs12 sm9",
                    label: "Giải thích chỉnh sửa",
                    disabled: false,
                    prepend_icon: "event_note",
                    rule: "require"
                },
                customers: {
                    hidden: true,
                },
            },
            trigger_edit_component: false
        };
	},
	watch: {
        'form.room_id'(nv){
            if (nv){
                this.getRoomState(nv)
                const chosen_room = this.rooms.find(room => room.room_id === nv)
                if (chosen_room.is_included_air_conditioner){
                    this.form.is_included_air_conditioner = true;
                    this.form.is_air_conditioner = true
                } else {
                    this.form.is_included_air_conditioner = false;
                    this.form.is_air_conditioner = ''
                }
            }
        },
        date_start: function(nv){
            if (nv && this.date_end) this.getData()
        },
        date_end: function(nv){
            if (nv && this.date_start) this.getData()
        }
    },
    created(){
        this.getData()
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        },
        role(){
            return this.$store.state.auth.role
        }
    },
    methods: {
        clearInput(){
            this.form = {
                receipt_id: '',
                building: '',
                room_id: '',
                date_in: new Date().toISOString().substr(0, 10),
                electric_count: '',
                water_count: '',
                is_washing_machine: '',
                is_air_conditioner: '',
                internet: '',
                internet_data: {},
                customers: [{}],
                member_count: 1,
                is_included_air_conditioner: false
            }
            this.$refs.form.resetValidation()
        },
        getRoomState: async function (roomId){
            this.form_loader = true
            this.alert.show = false
            const data = await api.getRoomState( "roomId=" + roomId )
            if ( data.status == 200 ){
                const is_valid_room_state = data.data && data.data.roomState ? data.data.roomState.is_valid : null
                const room_state_id = data.data && data.data.roomState ? data.data.roomState.room_state_id : null
                const check_in_id = data.data && data.data.roomState ? data.data.roomState.check_in_id : null
                if ( is_valid_room_state && room_state_id && !check_in_id ) {
                    this.form.room_state_id = room_state_id
                    const data_water_electric = await api.getBillsForCheckIn("roomId=" + roomId);
                    if (data_water_electric.status == 200){
                        const water_old = data_water_electric.data.water;
                        const electric_old = data_water_electric.data.electric;
                        this.form.water_old = water_old ? water_old.count : 0;
                        this.form.water_count = water_old ? water_old.count: 0;
                        this.form.electric_old = electric_old ? electric_old.count : 0;
                        this.form.electric_count = electric_old ? electric_old.count: 0;
                    }
                } else {
                    this.form.room_state_id = null
                    this.alert.show = true
                    this.alert.text = `Phòng ${ this.form.room_id } đã có người ở hoặc chưa được đặt phòng, vui lòng chọn chính xác phòng cần tạo phiếu`
                }
            } else {
                this.alert.show = true
                this.alert.text = data.message ? data.message : 'Đã xảy ra lỗi khi tải thông tin trạng thái phòng'
            }
            this.form_loader = false
        },
        getReceiptNewestNumber: async function (){
            this.form.receipt_id = this.form.building + '-1'
            this.form_loader = true
            const params = {
                receiptType: 'CHECK_IN',
                building: this.form.building
            }
            const query = buildParamQuery(params)
            const data = await api.getReceiptNumberNewest(query)
            if (data.status == 200 && data.data){
                const newest_array = data.data
                if (newest_array && newest_array.length){
                    this.form.receipt_id = this.form.building + '-' + (Number(newest_array[0].maxNumber) + 1)
                }
            }
            this.form_loader = false

        },
        validate: function (form){
            if ( !form.room_id ) return false
            if ( !form.receipt_id ) return false
            if ( !form.building ) return false
            if ( !form.water_count ) return false
            if ( !form.electric_count ) return false
            if ( !form.customers.filter(member => member.name) ) return false
            if ( !form.room_state_id ) return false
            return true
        },
        async submit() {
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            this.loading.submit = true
            this.form_loader = true
            let postData = Object.assign({}, this.form)
            postData.date_in = new Date(postData.date_in)
            postData.date_in_temp = new Date(postData.date_in)
            postData.customers = postData.customers.filter(member => member.name)
            postData.is_washing_machine = Boolean(postData.is_washing_machine);
            postData.is_air_conditioner = Boolean(postData.is_air_conditioner);
            let data = await api.createCheckInReceipt(postData)
            this.loading.submit = false
            this.form_loader = false
            if ( data.status === 200 ){
                swal.fire('Thành Công', data.data.message, 'success' )
                this.getData()
                this.clearInput()
                this.dialog = false
            } else swal.fire('Lỗi', data.message, 'error' )
        },
        getData: async function (){
            this.items = []
            this.loader = true
            const params = {
                // building: this.chosen_building,
                // [this.search_type]: this.search,
                dateStart: this.date_start,
                dateEnd: this.date_end,
            }
            const query = buildParamQuery(params)
            let data = await api.getCheckInReceipt(query)
            if ( data.status === 200){
                this.items = data.data.map( receipt => {
                    receipt.member_count = receipt.customers ? receipt.customers.length : 0
                    receipt.bike_count = receipt.customers.filter( customer => customer.is_bike ).length
                    receipt.motorbike_count = receipt.customers.filter( customer => customer.motorbike ).length
                    receipt.date_in = receipt.date_in.substr(0, 10)
                    return receipt
                })
            } else {
                swal.fire('Lỗi', data.message, 'error' )
            }
            this.loader = false
        },
        showDetail: function (receipt){
            this.chosen_receipt = receipt
            this.dialogDetail = true
        },
        handleCustomDate(date){
            date = date.toString()
            let year = date.slice(0, 4)
            let month = date.slice(4,6)
            let d = date.slice(6,8)
            return `${year}/${month}/${d}`
        },
        getDataDeposit: async function (){
            this.deposits = []
            let data = await api.getDepositReceipts()
            if ( data.status === 200){
                this.deposits = data.data.slice(0)
            }
            this.loader = false
        },
        cancelInput(){
            this.dialog = false
            this.clearInput()
            this.$refs.form.resetValidation()
        },
        updateCurrentReceipt(_id, updated_field){
            // const selected_receipt = this.items.find(receipt => receipt._id === _id);
            // for (const key in updated_field) {
            //     if (updated_field.hasOwnProperty(key)) {
            //         const element = updated_field[key];
            //         selected_receipt[key] = element;
            //     }
            // }
            this.getData();
        },
        updateCustomerCount(){
            console.log("run");
            const count = this.form.member_count
            this.form.member_count = count > 7 ? 7 : count < 1 ? 1 : this.form.member_count
            let diff = this.form.member_count - this.form.customers.length
            while (diff > 0){
                this.form.customers.push({}),
                diff--
            }
            if (diff < 0){
                this.form.customers.splice(count, -diff)
            }
        },
        removeCheckIn(receipt){
            let that = this
            swal.fire({
            title: 'Hủy phiếu nhận phòng',
            text: `Bạn có chắc muốn hủy phiếu nhận phòng:\n\nMã chứng từ: ${receipt.receipt_id}\nSố phòng ${receipt.room_id} ?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Hủy phiếu',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.$store.commit("loading", true)
                    let data = await api.removeCheckIn({receipt_id: receipt.receipt_id, room_state_id: receipt.room_state_id})
                    that.$store.commit("loading", false)
                    if (data.status == 200){
                        swal.fire('Thành công', data.data.message, 'success')
                        that.getData();
                    } else {
                        swal.fire('Lỗi', data.message, 'error')
                    }
                }
            })
        }
    }
};
</script>

<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>
